import { render, staticRenderFns } from "./HistoryDetails.vue?vue&type=template&id=4eb043b1&scoped=true"
import script from "./HistoryDetails.vue?vue&type=script&lang=js"
export * from "./HistoryDetails.vue?vue&type=script&lang=js"
import style0 from "./HistoryDetails.vue?vue&type=style&index=0&id=4eb043b1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4eb043b1",
  null
  
)

export default component.exports